import { getTimeRange } from '../../../../../../constants/helpers/dates';

import { CustomerValidationReportCreateForm } from './interfaces';

export const mapTableDataIntoApiFormat = (report: CustomerValidationReportCreateForm) => ({
  name: report.name,
  metadata: {
    timeRange: getTimeRange({ from: report.from, to: report.to }),
    statuses: report.statuses,
    queryTypes: report.queryTypes,
    operationIds: report.operationIds
  }
});
